import { cx } from "@emotion/css";
import MuiAccordion, {
	type AccordionProps as MuiAccordionProps,
} from "@mui/material/Accordion";
import MuiAccordionDetails, {
	type AccordionDetailsProps,
} from "@mui/material/AccordionDetails";
import MuiAccordionSummary, {
	type AccordionSummaryProps as MuiAccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import withStyles from "@mui/styles/withStyles";
import type { ReactNode } from "react";

interface AccordionProps extends MuiAccordionProps {
	children: ReactNode;
	className?: string;
}

const Accordion = ({ children, className, ...props }: AccordionProps) => {
	return (
		<MuiAccordion className={cx("accordion", className)} {...props}>
			{children}
		</MuiAccordion>
	);
};

const MUIAccordionDetails = withStyles({
	root: {
		display: "block",
	},
})(MuiAccordionDetails);

const AccordionDetails = (props: AccordionDetailsProps) => {
	return <MUIAccordionDetails {...props} />;
};

interface AccordionSummaryProps extends MuiAccordionSummaryProps {
	className?: string;
}

const AccordionSummary = ({ className, ...props }: AccordionSummaryProps) => {
	return (
		<MuiAccordionSummary
			className={cx(className, "accordion-summary")}
			{...props}
		/>
	);
};

export { Accordion, AccordionDetails, AccordionSummary };
